import { FC, useRef, useMemo, useCallback } from 'react'
import { ThemeProvider } from 'styled-components'
import GlobalStyles from '../styles/Global'
import theme from '../styles/theme'
import * as header from '../styles/Header.styled'
import * as app from '../styles/App.styled'
import * as myTitles from '../styles/Titles.styled'
import { TechStack } from './TechStack'
import { Bio } from './Bio'
import { Work } from './Work'
import { Projects } from './Projects'
import useResponsiveWidth from '../hooks/useResponsiveWidth'
import logo from '../assets/logo.svg'
import { WidthCategory } from '../typing/enums'

export const App: FC = () => {
  const headerRef = useRef(null)
  const { widthCategory } = useResponsiveWidth()

  const isMedium = useMemo<boolean>(() => {
    return (widthCategory === WidthCategory.medium)
  }, [widthCategory])

  const titles = useMemo(() => {
    const titleNames = {
      aboutME: '{ about me }',
      selectTechnologies: '{ select technologies }',
      projectSamples: '{ project samples }',
      workHistory: '{ work history }',
    }

    return Object.values(titleNames)
      .reduce((acc:string[], title:string) => {
        const { workHistory } = titleNames

        const willHide = (
          [workHistory].includes(title) &&
          isMedium
        )

        return (!willHide)
          ? [...acc, title]
          : [...acc]
      }, [])
  }, [isMedium])

  const getTop = useCallback(({
    sectionNumber,
  }:{
    sectionNumber:number,
  }):string => {
    const top = theme.sizes.heights.title({
      sectionNumber,
      isMedium,
    })

    return top
  }, [isMedium])

  const Titles: FC = () => {
    return (
      <>
        {
          titles.map((title:string, index:number) => {
            return (
              <myTitles.StyledTitle
                key={index}
                $index={index}
                $top={getTop({ sectionNumber: index })}
              >
                {title}
              </myTitles.StyledTitle>
            )
          })
        }
      </>
    )
  }

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <header.StyledHeader ref={headerRef}>
        <header.StyledLogo
          src={logo}
          alt={'logo'}
          drag={(!isMedium)}
          dragConstraints={headerRef}
          dragTransition={{
            power: 0.3,  // reduce momentum strength (default is 0.8)
            timeConstant: 300,  // increase to make it settle more slowly
          }}
        />
        <header.StyledName>
          David Kontrovitz
        </header.StyledName>
        <header.StyledJobTitle>
          Software Engineer
        </header.StyledJobTitle>
      </header.StyledHeader>
      <Titles />
      <app.StyledMain>
        <Bio />
        <TechStack />
        <Projects />
        {(!isMedium) && <Work />}
      </app.StyledMain>
    </ThemeProvider>
  )
}
